export enum FormIds {
  POLICY_SCAN_SURVEY_FORM = 'policy-scan-survey-form',
  POLICY_SCAN_MBI_SURVEY_FORM = 'policy-scan-mbi-survey-form-2',
  POLICY_PURCHASE_SURVEY_FORM = 'policy-purchase-survey-form',
  POLICY_PURCHASE_EXIT_SURVEY_FORM = 'policy-purchase-exit-survey-form',
  LIFE_POLICY_SCAN_SURVEY_FORM = 'life-policy-scan-survey-form',
  POLICY_SCAN_SURVEY_FORM_TOWER = 'policy-scan-survey-tower-form',
}
